import { env } from "~/env";
import { Appointment, useAppointmentsListQuery } from "~/services";
import { Button, useCooldown } from "~/shared";
import { icons } from "~/ui";
import { tw } from "~/utils";
import { UserDetailRow } from ".";
import { VisitCard, VisitHistoryTable } from "./components";

export const UserVisitsSection = ({ userId }: { userId: string }) => {
  const {
    data: appointments,
    isFetching,
    refetch,
  } = useAppointmentsListQuery(userId);

  const isCooldown = useCooldown(
    isFetching,
    env.VITE_APPOINTMENT_VISITS_COOLDOWN,
  );

  const {
    upcomingAppointments = [],
    appointmentsHistory = [],
    insurance,
  } = appointments ?? {};
  return (
    <div className="flex flex-col gap-5">
      <UserDetailRow
        field="Visits"
        value={
          <Button
            variant="info"
            size="sm"
            className={tw("gap-2", isCooldown ? "opacity-50" : "")}
            onClick={() => {
              if (!isFetching && !isCooldown) {
                refetch();
              }
            }}
          >
            <icons.outline.ArrowPathIcon
              className={tw(
                "size-6 stroke-2",
                isFetching ? "animate-spin" : "",
              )}
            />
            Load visits
          </Button>
        }
      />
      {appointments && (
        <>
          {insurance && (
            <div className={"flex flex-col gap-2"}>
              <div className="align-middle text-xs font-medium text-neutral-600">
                PATIENT INSURANCE
              </div>
              <span className="text-neutral-900">
                {insurance.name} - [{insurance.ehrId}]
              </span>
            </div>
          )}
          <div className={"flex flex-col gap-2"}>
            <div className="align-middle text-xs font-medium text-neutral-600">
              UPCOMING VISITS
            </div>
            <div className="flex flex-col gap-2">
              {upcomingAppointments.length > 0 ? (
                upcomingAppointments.map((appointment: Appointment) => (
                  <VisitCard
                    key={appointment.id}
                    visit={appointment}
                    showCancelButton
                  />
                ))
              ) : (
                <div className="p-4 text-center text-sm text-neutral-600">
                  No upcoming visits.
                </div>
              )}
            </div>
          </div>
          <div className={"flex flex-col gap-2"}>
            <div className="align-middle text-xs font-medium text-neutral-600">
              VISIT HISTORY
            </div>
            <VisitHistoryTable data={appointmentsHistory} />
          </div>
        </>
      )}
    </div>
  );
};
